/**
 * 🎟️ O BILHETE DO PDF (relatório 48 §4): enquanto há sessão, troca o crachá por um bilhete de 10 min (POST /pdf/bilhete)
 * e o renova a cada 4 min; instala a troca do link no clique. Não desenha nada.
 *
 * Mora FORA do `useAuth` de propósito: as telas enterradas da v1 dependem do `useAuth`, e a régua delas conta toda
 * chamada de API alcançável a partir dali. A chamada do bilhete no hook subia as cinco em 1 cada.
 * Montado uma vez no App, dentro do AuthProvider.
 */
import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { apiFetch } from "../lib/api";
import { renovarBilhetePdf, limparBilhetePdf, trocarNoClique, RENOVAR_BILHETE_MS } from "../lib/pdfHref";

export function BilheteDoPdf(): null {
  const { session } = useAuth();
  const tokenDaSessao = session?.access_token ?? null;
  useEffect(() => {
    if (!tokenDaSessao) { limparBilhetePdf(); return; }
    trocarNoClique();
    const pedir = (t: string) => apiFetch<{ bilhete: string; vence_em: string }>("/pdf/bilhete", t, { method: "POST" });
    void renovarBilhetePdf(tokenDaSessao, pedir);
    const id = setInterval(() => { void renovarBilhetePdf(tokenDaSessao, pedir); }, RENOVAR_BILHETE_MS);
    return () => clearInterval(id);
  }, [tokenDaSessao]);
  return null;
}
